<template>
	<div class="sky-input" :style="$attrs.style" v-html="selfData"></div>
</template>
<script>
import formStore from '@/mixins/formStore.js';
export default {
	name: 'sky-text',
	mixins: [formStore],
	data() {
		return {
			val: '',
		};
	},
	methods: {
		change(val) {
			this.selfData = val;
		},
	},
};
</script>
<style scoped lang="scss"></style>
